module.exports = __webpack_public_path__ + "img/lv3-1.fb6b9db5.png";